import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-up-bar', 'ArrowUpBar', [["path",{"d":"M12 21l0 -18"}],["path",{"d":"M15 6l-3 -3l-3 3"}],["path",{"d":"M9 21l6 0"}]]);